import { CLEAR_APPLICATION_DATA, SAVE_PRE_NCE_INFO } from "../constant";

export const preNceApplicationInitialState = (data) => {
	return {
		studentTypeId: data?.studentTypeId,
		...(data?.applicationType && {
			applicationType: {
				label: data?.applicationType,
				value: data?.applicationTypeId
			}
		}),
		passport: {
			passport: data?.passport
		},
		...(data?.sessionId && {
			sessionId: {
				value: data?.sessionId,
				label: data?.session
			}
		}),
		regNumber: data?.regNumber,
		basicInformation: {
			applicationNumber: data?.personalInfoResponse?.applicationNumber,
			rrr: data?.personalInfoResponse?.rrr,
			surname: data?.personalInfoResponse?.surname,
			firstname: data?.personalInfoResponse?.firstname,
			middlename: data?.personalInfoResponse?.middlename,
			homeTown: data?.personalInfoResponse?.homeTown,
			...(data?.personalInfoResponse?.genderId && {
				genderId: {
					value: data?.personalInfoResponse?.genderId,
					label: data?.personalInfoResponse?.gender
				}
			}),
			dateOfBirth: data?.personalInfoResponse?.dateOfBirth,
			...(data?.personalInfoResponse?.country && {
				countryId: {
					value: data?.personalInfoResponse?.countryId,
					label: data?.personalInfoResponse?.country
				}
			}),
			nin: data?.personalInfoResponse?.nin,
			...(data?.personalInfoResponse?.stateId && {
				stateId: {
					value: data?.personalInfoResponse?.stateId,
					label: data?.personalInfoResponse?.state
				}
			}),
			...(data?.personalInfoResponse?.lgaId && {
				lgaId: {
					value: data?.personalInfoResponse?.lgaId,
					label: data?.personalInfoResponse?.lga
				}
			}),
			contactAddress: data?.personalInfoResponse?.contactAddress,
			mobileNumber: data?.personalInfoResponse?.mobileNumber,
			...(data?.personalInfoResponse?.religionId && {
				religionId: {
					value: data?.personalInfoResponse?.religionId,
					label: data?.personalInfoResponse?.religion
				}
			}),
			email: data?.personalInfoResponse?.email,
			disability: data?.personalInfoResponse?.disability
		},
		programmeDetails: {
			applicationType: data?.applicationType ?? null,
			applicationTypeId: data?.applicationTypeId ?? null,
			rrr: data?.programmeInfoResponse?.rrr ?? null,

			facultyId:
				data?.programmeInfoResponse?.facultyId != null
					? {
							value: data.programmeInfoResponse.facultyId,
							label: data.programmeInfoResponse.faculty
					  }
					: null,
			alternativeFacultyId:
				data?.programmeInfoResponse?.alternateFacultyId != null
					? {
							value: data.programmeInfoResponse
								.alternateFacultyId,
							label: data.programmeInfoResponse.alternateFaculty
					  }
					: null,

			departmentId:
				data?.programmeInfoResponse?.departmentId != null
					? {
							value: data.programmeInfoResponse.departmentId,
							label: data.programmeInfoResponse.department
					  }
					: null,
			programmeCategoryId:
				data?.programmeInfoResponse?.programmeCategoryId != null
					? {
							value: data.programmeInfoResponse
								.programmeCategoryId,
							label: data.programmeInfoResponse.programmeCategory
					  }
					: null,
			programmeTypesId:
				data?.programmeInfoResponse?.programmeTypeId != null
					? {
							value: data.programmeInfoResponse.programmeTypeId,
							label: data.programmeInfoResponse.programmeType
					  }
					: null,
			alternativeDepartmentId:
				data?.programmeInfoResponse?.alternateDepartmentId != null
					? {
							value: data.programmeInfoResponse
								.alternateDepartmentId,
							label: data.programmeInfoResponse
								.alternateDepartment
					  }
					: null,

			jambRegNumber: data?.regNumber,

			departmentOptionId:
				data?.programmeInfoResponse?.departmentOptionId != null
					? {
							value: data.programmeInfoResponse
								.departmentOptionId,
							label: data.programmeInfoResponse.departmentOption
					  }
					: null,

			programmeId:
				data?.programmeInfoResponse?.programmeId != null
					? {
							value: String(
								data.programmeInfoResponse.programmeId
							),
							label: data.programmeInfoResponse.programme
					  }
					: null,

			firstSubjectId:
				data?.programmeInfoResponse?.firstSubjectId != null
					? {
							value: data.programmeInfoResponse.firstSubjectId,
							label: data.programmeInfoResponse.firstSubject
					  }
					: null,

			secondSubjectId:
				data?.programmeInfoResponse?.secondSubjectId != null
					? {
							value: data.programmeInfoResponse.secondSubjectId,
							label: data.programmeInfoResponse.secondSubject
					  }
					: null,

			thirdSubjectId:
				data?.programmeInfoResponse?.thirdSubjectId != null
					? {
							value: data.programmeInfoResponse.thirdSubjectId,
							label: data.programmeInfoResponse.thirdSubject
					  }
					: null,

			fourthSubjectId:
				data?.programmeInfoResponse?.fourthSubjectId != null
					? {
							value: data.programmeInfoResponse.fourthSubjectId,
							label: data.programmeInfoResponse.fourthSubject
					  }
					: null,

			utmeScore: data?.programmeInfoResponse?.utmeScore ?? null
		},
		nextOfKin: {
			id: data?.nextOfKin?.id,
			fullname: data?.personalInfoResponse?.nextOfKinFullName,
			...(data?.personalInfoResponse?.nextOfKinRelationshipId && {
				relationshipId: {
					value: data?.personalInfoResponse?.nextOfKinRelationshipId,
					label: data?.personalInfoResponse?.nextOfKinRelationship
				}
			}),
			mobileNumber: data?.personalInfoResponse?.nextOfKinMobileNumber,
			email: data?.nextOfKin?.email,
			address: data?.personalInfoResponse?.nextOfKinContactAddress
		},
		educationalHistory: data?.educationHistoryResponse,

		oLevelResponse: {
			sittings: data?.olevelResponse?.map((item) => ({
				...item,
				resultPin: item?.resultPin,
				resultPinSno: item?.resultSerialNumber,
				examNumber: item?.examNumber,
				examCentre: item?.examCenter,
				oLevelType: {
					value: item?.examinationTypeId,
					label: item?.examinationType
				},
				examYear: { value: item?.examYear, label: item?.examYear },
				subjects: [
					...Object?.keys(item?.subjectGrade).map((key, index) => ({
						subject: {
							label: key?.toUpperCase(),
							value: Object?.keys(item?.subjectGradeId)?.[index]
						},
						grade: {
							label: item?.subjectGrade?.[key],
							value: Object?.values(item?.subjectGradeId)?.[index]
						}
					}))
				]
			}))
		}
	};
};

export const preNceReducer = (state = {}, action) => {
	switch (action.type) {
		case SAVE_PRE_NCE_INFO:
			return action.payload;
		case CLEAR_APPLICATION_DATA:
			return {};
		default:
			return state;
	}
};
